import { Box, Stack, SxProps, Typography } from "@mui/material";
import { colorLandingBrand, colorLandingText } from "src/design/tokens";

interface FeatureCheckListProps {
  items: string[];
  fontSize?: number;
  sx?: SxProps;
}

const CheckIcon = () => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.5}
    aria-hidden="true"
    sx={{
      width: 17,
      height: 17,
      flexShrink: 0,
      mt: "3px",
      color: colorLandingBrand,
    }}
  >
    <polyline points="20 6 9 17 4 12" />
  </Box>
);

/**
 * The brand check-mark bullet list repeated across the showcase panels, the
 * consumer-app section and the pricing cards.
 */
export const FeatureCheckList = ({
  items,
  fontSize = 14.5,
  sx,
}: FeatureCheckListProps) => (
  <Stack component="ul" spacing={1.125} sx={{ listStyle: "none", p: 0, m: 0, ...sx }}>
    {items.map((item) => (
      <Box
        component="li"
        key={item}
        sx={{ display: "flex", gap: 1.125, alignItems: "flex-start" }}
      >
        <CheckIcon />
        <Typography sx={{ fontSize, color: colorLandingText, lineHeight: 1.5 }}>
          {item}
        </Typography>
      </Box>
    ))}
  </Stack>
);
